export const SettingsContainer = () => {
    return (
        <span>Settings</span>
    );
};